<template>
  <div>
    <!-- 动态设置页面标题和meta标签 -->
  </div>
</template>

<script>
export default {
  name: 'SEOHead',
  props: {
    title: {
      type: String,
      default: '湖北智寰科技官网 - 七鼠智服AI智能客服系统'
    },
    description: {
      type: String,
      default: '湖北智寰科技专注AI智能客服系统研发，七鼠智服基于千亿大模型，为电商企业提供智能客服解决方案。'
    },
    keywords: {
      type: String,
      default: '湖北智寰科技,智寰科技官网,七鼠智服,七鼠智服官网,AI智能客服,电商客服系统,人工智能客服'
    },
    structuredData: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.updateSEO()
  },
  watch: {
    title: 'updateSEO',
    description: 'updateSEO',
    keywords: 'updateSEO'
  },
  methods: {
    updateSEO() {
      // 更新页面标题
      document.title = this.title
      
      // 更新meta description
      this.updateMetaTag('name', 'description', this.description)
      
      // 更新meta keywords
      this.updateMetaTag('name', 'keywords', this.keywords)
      
      // 更新Open Graph标签
      this.updateMetaTag('property', 'og:title', this.title)
      this.updateMetaTag('property', 'og:description', this.description)
      
      // 更新Twitter Cards
      this.updateMetaTag('name', 'twitter:title', this.title)
      this.updateMetaTag('name', 'twitter:description', this.description)
      
      // 添加结构化数据
      if (this.structuredData) {
        this.addStructuredData(this.structuredData)
      }
    },
    
    updateMetaTag(attribute, name, content) {
      let element = document.querySelector(`meta[${attribute}="${name}"]`)
      if (element) {
        element.setAttribute('content', content)
      } else {
        element = document.createElement('meta')
        element.setAttribute(attribute, name)
        element.setAttribute('content', content)
        document.getElementsByTagName('head')[0].appendChild(element)
      }
    },
    
    addStructuredData(data) {
      // 移除已存在的结构化数据
      const existingScript = document.querySelector('script[type="application/ld+json"][data-page]')
      if (existingScript) {
        existingScript.remove()
      }
      
      // 添加新的结构化数据
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.setAttribute('data-page', 'true')
      script.textContent = JSON.stringify(data)
      document.getElementsByTagName('head')[0].appendChild(script)
    }
  }
}
</script>
